import parserDefault from './funcscript-parser.js';
import * as parserNamespace from './funcscript-parser.js';

const parser = parserDefault ?? (parserNamespace?.default ?? parserNamespace);

export const {
  FuncScriptParser,
  ParseNodeType,
  SyntaxErrorData,
  ParseNode,
  ParseContext,
  ParseResult,
  ParseBlockResult,
  ParseBlockResultWithNode,
  ValueParseResult,
  IdenResult,
  getExpression,
  getInfixExpression,
  getInfixExpressionSingleLevel,
  getInfixExpressionSingleOp,
  getInfixFunctionCall,
  getOperator,
  getCallAndMemberAccess,
  getFunctionCallParametersList,
  getKvcExpression,
  getKvcItem,
  getKeyValuePair,
  getReturnDefinition,
  getListExpression,
  getSpaceSeparatedListExpression,
  getSpaceSeparatedStringListExpression,
  getFSTemplate,
  getStringTemplate,
  getUnit,
  getIfThenElseExpression,
  getCaseExpression,
  getSwitchExpression,
  getLambdaExpression,
  getIdentifierList,
  getPrefixOperator,
  getRootExpression,
  createNodeBuffer,
  commitNodeBuffer,
  getLiteralMatch,
  getToken,
  getWhitespaceToken,
  skipSpace,
  getSimpleString,
  getSpaceLessString,
  getIdentifier,
  getKeyWord,
  getKeyWordLiteral,
  getNumber,
  getInt,
  identifierMetrics,
  literalMatchMetrics,
  resetIdentifierMetrics,
  resetLiteralMatchMetrics
} = parser;

export default parser;
